import React, { useEffect, useState } from 'react';
import { Checkbox, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { NAME_DEV_SET } from '../../../function/NameDevSetModel';
import { TextField } from '@material-ui/core';
import { NAME_ITEM_SET } from './CollectSetting/CollectSettingDefine';

type ItemRegistGridBodyProps = {
  indexNo: number;
  item: NAME_ITEM_SET;
  updateItem: (item: NAME_ITEM_SET) => void;
};

const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    tableItem: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      orderBottomStyle: 'inset',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      textAlign: 'center',
      minWidth: '80px',
      height: '8px',
      padding: '1px',
    },
    tableItemL: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      orderBottomStyle: 'inset',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      textAlign: 'left',
      minWidth: '80px',
      height: '8px',
      padding: '1px',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      border: 'none',
    },
  })
);

const ItemRegistGridBody: React.FC<ItemRegistGridBodyProps> = (props: ItemRegistGridBodyProps) => {
  const classes = useStyles();
  const [est, setEst] = useState<boolean>(props.item.EST != 0);
  const [itemName, setItemName] = useState<string>(props.item.ITM_NAME);

  useEffect(() => {}, []);

  return (
    <TableRow key={props.item.ITM_NAME_NO}>
      <TableCell className={classes.tableItem} width={'40px'}>
        {props.indexNo + 1}
      </TableCell>
      <TableCell className={classes.tableItem} width={'40px'}>
        <input
          type="checkbox"
          checked={est}
          onChange={(e) => {
            setEst(e.target.checked);
            props.item.EST = e.target.checked ? 1 : 0;
            props.updateItem(props.item);
          }}
        />
      </TableCell>
      <TableCell className={classes.tableItemL}>
        <input
          className={classes.textField}
          maxLength = {32}
          type="text"
          value={itemName}
          onChange={(e) => {
            setItemName(e.target.value);
            props.item.ITM_NAME = e.target.value;
            props.updateItem(props.item);
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default ItemRegistGridBody;
